export const types = {
  GET_EMPLOYEEDATA_REQUEST: "GET_EMPLOYEEDATA_REQUEST",
  GET_EMPLOYEEDATA_SUCCESS: "GET_EMPLOYEEDATA_SUCCESS",
  GET_EMPLOYEEDATA_FAILED: "GET_EMPLOYEEDATA_FAILED",

  GET_EMPLOYEE_ATTENDANCE_REQUEST: "GET_EMPLOYEE_ATTENDANCE_REQUEST",
  GET_EMPLOYEE_ATTENDANCE_SUCCESS: "GET_EMPLOYEE_ATTENDANCE_SUCCESS",
  GET_EMPLOYEE_ATTENDANCE_FAILED: "GET_EMPLOYEE_ATTENDANCE_FAILED",

  

  GET_BRANCHES_REQUEST: "GET_BRANCHES_REQUEST",
  GET_BRANCHES_SUCCESS: "GET_BRANCHES_SUCCESS",
  GET_BRANCHES_FAILED: "GET_BRANCHES_FAILED",

  GET_ADMINTICKET_REQUEST: "GET_ADMINTICKET_REQUEST",
  GET_ADMINTICKET_SUCCESS: "GET_ADMINTICKET_SUCCESS",
  GET_ADMINTICKET_FAILED: "GET_ADMINTICKET_FAILED",

  
  GET_EMPLOYEE_LEAVE_WFH_REQUEST: "GET_EMPLOYEE_LEAVE_WFH_REQUEST",
  GET_EMPLOYEE_LEAVE_WFH_SUCCESS: "GET_EMPLOYEE_LEAVE_WFH_SUCCESS",
  GET_EMPLOYEE_LEAVE_WFH_FAILED: "GET_EMPLOYEE_LEAVE_WFH_FAILED",

  GET_ASSETS_REQUEST: "GET_ASSETS_REQUEST",
  GET_ASSETS_SUCCESS: "GET_ASSETS_SUCCESS",
  GET_ASSETS_FAILED: "GET_ASSETS_FAILED",

  GET_REPORTING_MANAGER_REQUEST: "GET_REPORTING_MANAGER_REQUEST",
  GET_REPORTING_MANAGER_SUCCESS: "GET_REPORTING_MANAGER_SUCCESS",
  GET_REPORTING_MANAGER_FAILED: "GET_REPORTING_MANAGER_FAILED",

  GET_DEPARTMENT_REQUEST: "GET_DEPARTMENT_REQUEST",
  GET_DEPARTMENT_SUCCESS: "GET_DEPARTMENT_SUCCESS",
  GET_DEPARTMENT_FAILED: "GET_DEPARTMENT_FAILED",

  GET_SHIFT_REQUEST: "GET_SHIFT_REQUEST",
  GET_SHIFT_SUCCESS: "GET_SHIFT_SUCCESS",
  GET_SHIFT_FAILED: "GET_SHIFT_FAILED",


  GET_LEAVE_REQUEST: "GET_LEAVE_REQUEST",
  GET_LEAVE_SUCCESS: "GET_LEAVE_SUCCESS",
  GET_LEAVE_FAILED: "GET_LEAVE_FAILED",


  GET_WFH_REQUEST: "GET_WFH_REQUEST",
  GET_WFH_SUCCESS: "GET_WFH_SUCCESS",
  GET_WFH_FAILED: "GET_WFH_FAILED",
};
